<template>
  <div class="content" ref="content">
    <div class="header">
        <div class="">
          <img src="../assets/join-shuye.png" class="join-shuye" alt="">
        </div>
        <div class="">
          <img v-if="iscn" src="../assets/join-header-1.png" class="join-header-1 animate__animated" alt="">
          <img v-else src="../assets/join-header-1-en.png" class="join-header-1 join-header-1-en animate__animated" alt="">
        </div>
        <div class="">
          <img v-if="iscn" src="../assets/join-header-2.png" class="join-header-2 animate__animated" alt="">
          <div v-else class="join-header-2-en animate__animated" >Circular consumption is not just a choice; it is a shift in lifestyle. Every small action contributes to the green power of protecting the Earth.</div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.join-shuye', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.join-header-1', {
      speed: 2,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.join-header-2', {
      speed: 2,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target.classList.contains('join-shuye') && entry.isIntersecting) {
              setTimeout(() => {
                entry.target?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('join-header-1') && entry.isIntersecting) {
              setTimeout(() => {
                entry.target?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('join-header-2') && entry.isIntersecting) {
              setTimeout(() => {
                entry.target?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('join-header-2-en') && entry.isIntersecting) {
              setTimeout(() => {
                entry.target?.classList?.add('fade-in')
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.join-shuye') as Element)
      observer.observe(document.querySelector('.join-header-1') as Element)
      const header2 = document.querySelector('.join-header-2')
      header2 && observer.observe(header2)
      const header2En = document.querySelector('.join-header-2-en')
      header2En && observer.observe(header2En)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 1s 0s forwards;
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-pic {
  animation: zoomInPic 1s 0s forwards;
}

.earth-banner-up {
  animation: slideUp 0.8s 0s forwards;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 988px;
  margin: 0 auto;
  background: #fff;
}
.header {

}
.join-shuye {
  position: absolute;
  width:1900px;
  height:319px;
  top: 129px;
  left: 50%;
  margin-left: -950px;
  opacity: 0;
}
.join-header-1 {
  position: absolute;
  width:1198px;
  height:136px;
  top: 460px;
  left: 50%;
  margin-left: -599px;
  opacity: 0;
  &.join-header-1-en {
    width:1527px;
    height:204px;
    margin-left: -764px;
  }
}
.join-header-2 {
  position: absolute;
  width:600px;
  // height:72px;
  top: 656px;
  left: 50%;
  margin-left: -300px;
  opacity: 0;
}
.join-header-2-en {
  position: absolute;
  top: 704px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #111111;
  line-height: 36px;
  left: 50%;
  white-space: nowrap;
  transform: translate(-50%, 0);
  opacity: 0;
}
// .earth-banner {
//   position: absolute;
//   top: 0;
//   text-align: center;
//   width: 1538px;
//   left: 50%;
//   // width: 1539px;
//   // height: 807px;
//   margin-left: -769px;
//   // background: url('../assets/pic-5.png') no-repeat 0 0/ 100% 100%;
//   // y轴向下偏移100像素
//   // transform: translateY(200px);
//   .bingchuan-title {
//     width: 992px;
//     height: 96px;
//     margin: 0 auto;
//     position: absolute;
//     left: 50%;
//     margin-left: -486px;
//   }
//   .bingchuan-bg {
//     position: absolute;
//     top: 216px;
//     left: 50%;
//     width: 1538px;
//     height: 720px;
//     margin-left: -769px;
//     opacity: 0;
//   }
//   .bingchuan-mark-1 {
//     position: absolute;
//     top: 342px;
//     left: 263px;
//     width: 232px;
//     height: 108px;
//     opacity: 0;
//     &.bingchuan-mark-1-en {
//       width: 343px;
//     }
//   }
//   .bingchuan-mark-2 {
//     position: absolute;
//     top: 642px;
//     left: 114px;
//     width: 481px;
//     height: 48px;
//     opacity: 0;
//     &.bingchuan-mark-2-en {
//       width: 514px;
//     }
//   }
//   .bingchuan-31 {
//     position: absolute;
//     top: 1136px;
//     left: 0px;
//     width: 640px;
//     height: 588px;
//     opacity: 0;
//   }
//   .bingchuan-arrow {
//     position: absolute;
//     top: 1411px;
//     left: 734px;
//     width: 32px;
//     height: 37px;
//     opacity: 0;
//   }
//   .bingchuan-co2 {
//     position: absolute;
//     top: 1180px;
//     left: 834px;
//     width: 652px;
//     height: 500px;
//     opacity: 0;
//   }
//   .bingchuan-sweat {
//     position: absolute;
//     top: 1218px;
//     left: 1405px;
//     width: 125px;
//     height: 114px;
//     opacity: 0;
//   }
// }
</style>
